import React, { Component } from "react";
import Config from "../../config/config";

const resizeIframe = (counter = 0) => {
  const obj = document.getElementById('embeded-scorm');

  if (obj.contentWindow.document.documentElement.scrollHeight >= 1200) {
    obj.parentNode.style.minHeight = null;
    return;
  }

  obj.parentNode.style.minHeight = obj.contentWindow.document.documentElement.scrollHeight;

  if (counter < 10) {
    setTimeout(() => {
      resizeIframe(counter + 1);
    }, 1000);
  }
};

export class Scorm extends Component {
  renderIframe() {
    return (
      <div className="embed-responsive embed-responsive-4by3 card shadow-sm">
        <iframe
          className="embed-responsive-item"
          allowFullScreen
          webkitallowfullscreen="true"
          id="embeded-scorm"
          mozallowfullscreen="true"
          src={Config.baseUrl + "/lms/assets/scorm/" + this.props.course.scorm}
          scrolling="yes"
          frameBorder="0"
          allow="geolocation; microphone; camera; encrypted-media; midi"
        ></iframe>
      </div>
    );
  }

  renderMessage() {
    const scormUrl = Config.baseUrl + "/lms/assets/scorm/" + this.props.course.scorm;
    var largura = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var altura = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    return (
      <div className="card shadow-sm card-embed">
        <div className="embed-external">
          <p className="embed-text">Por favor, clique abaixo para abrir o conteúdo interativo em uma nova janela do seu navegador</p>
          <button type="button" class="btn btn-outline-light" onClick={() => window.open(scormUrl,'_blank', 'width=' + largura + ', height=' + altura +',noopener,noreferrer')}>
            Abrir conteúdo interativo
          </button>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div
          id="twig-scorm-data"
          student-id="17305"
          sco-id="251"
          student-name="Vitor, Samba"
          score-raw="0"
          score-min="0"
          score-max="0"
          total-time="0"
          credit="no-credit"
          lesson-status="incomplete"
          lesson-location="0"
          exit=""
          entry=""
          lesson-mode="normal"
          suspend-data=""
          course-id="244"
          lesson-id="537"
          mastery-score=""
        ></div>

        {this.props.course.external_view === 1
          ? this.renderMessage()
          : this.renderIframe()}
      </div>
    );
  }
}

export default Scorm;



// WEBPACK FOOTER //
// ./src/components/Course/Scorm.jsx